export default __webpack_public_path__ + "static/media/ai-warehousing.66f8198a.png";